import { render } from "./OffCanvasMenu.vue?vue&type=template&id=ee4a573c"
import script from "./OffCanvasMenu.vue?vue&type=script&lang=js"
export * from "./OffCanvasMenu.vue?vue&type=script&lang=js"

import "./OffCanvasMenu.vue?vue&type=style&index=0&id=ee4a573c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__